export default "__VITE_ASSET__DA82C3sM__"